module.exports = __webpack_public_path__ + "img/shape.a2103556.png";